import React from "react";
import { Box, CircularProgress } from "@mui/material";

/** Centered spinner filling the viewport, shown while the auth stack settles. */
const FullScreenSpinner: React.FC = () => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
    }}
  >
    <CircularProgress size={48} />
  </Box>
);

export default FullScreenSpinner;
